// extracted by mini-css-extract-plugin
export default {"table":"SiteInfoTable_table__GJFcM"};